import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-prod-package",
  "use": "icon-prod-package-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-prod-package\"><path d=\"M110,196.44,35.14,153.22V66.78L110,23.56l74.86,43.22v86.44ZM44.14,148l65.86,38,65.86-38V72L110,34,44.14,72Z\" /><polygon points=\"110 114.74 37.39 72.82 41.89 65.02 110 104.35 178.11 65.02 182.61 72.82 110 114.74\" /><rect x=\"105.39\" y=\"108.93\" width=\"9\" height=\"81.25\" /><rect x=\"71.69\" y=\"90.99\" width=\"9\" height=\"41.02\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol